<template>
  <div v-if="content">
    <div class="max-w-6xl mx-auto text-xl md:text-3xl px-6">
      <h1 class="my-12 text-center">{{ content.title }}</h1>
      <div
        v-if="content.image"
        v-html="content.image"
        class="my-12 flex justify-center"
      ></div>
      <div v-html="content.text" />

      <div v-if="content.events.length" class="mt-16">
        <div class="w-32 border-white border-t" />
        <h2 class="mt-6">Events & Recordings</h2>
        <router-link
          class="block mt-8"
          v-for="event in content.events"
          :key="event.link"
          :to="event.link"
        >
          <h2 class="text-base mono uppercase">
            {{ event.date }}, {{ event.parent }}
          </h2>
          <h3 class="mt-1 mono">{{ event.title }}</h3>
          <div
            v-if="event.description"
            v-html="event.description"
            class="mt-4 text-lg"
          />
        </router-link>
      </div>
    </div>

    <Separator
      pattern="oval"
      class="mt-48 w-full h-20 border-t border-white border-b"
    />
    <Separator
      pattern="crest"
      class="mt-3 w-full h-16 border-t border-white border-b"
    />
    <Separator pattern="brick" class="mt-3 w-full h-32 border-t border-white" />
  </div>
</template>

<script>
import Separator from "@/components/Separator.vue"
export default {
  name: "Person",
  data() {
    return {
      content: null,
    }
  },
  components: {
    Separator,
  },
  mounted() {
    fetch(
      `${process.env.VUE_APP_API_ROOT}/people/${this.$route.params.slug}.json`,
      {
        mode: "cors",
      }
    ).then((res) => {
      res.json().then((json) => (this.content = json))
    })
  },
}
</script>
